import { Conversation } from '@/types/conversation.types';
import { errorBody } from '@/types/socketResponse.type';

export interface ConversationStatusUpdate {
  status: string;
  conversation_id: string | undefined;
}

export enum CONVERSATION_LIST_MODE {
  GENERAL_VIEW = 'GENERAL_VIEW',
  CONTACT_VIEW = 'CONTACT_VIEW',
}

export type GetConversations = {
  conversations: Conversation[];
  count: number;
  page: number;
  error: string | errorBody | null;
};

export type DownloadChatResponse = {
  fileName: string;
  fileData: string;
};
